export const orderDetails = {
  orderId: '64de12c3e4b00b5b3f3b8ff5',
  clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
  merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
  locationId: '985487d9-f4bf-4f57-a964-436d2fca267a',
  orderName: 'Order for Devanshani Rasanjika',
  orderNumber: '70',
  extOrderId: 'e3eb9135-4d91-461d-86f3-fd3eea68b6bc',
  orderType: 'PICKUP',
  customer: {
    customerId: '3196b5ce-2d63-49d3-8d55-14ac010ad734',
    extCustomerId: '45764',
    firstName: 'Devanshani',
    lastName: 'Rasanjika',
    email: 'devanshani.r@aeturnum.com',
    phone: '2311111111',
  },
  guestCount: 0,
  delivery: {
    deliveryAddress: null,
    deliveryInstructions: null,
  },
  status: 'CLOSED',
  orderNote: 'Pick 01',
  orderFulfillTime: '2023-08-17T18:50:00',
  closedTime: '2023-08-17T18:41:24.884',
  createdDate: '2023-08-17T17:59:55.571',
  updatedDate: '2023-08-17T18:18:51.745',
  orderItems: [
    {
      orderItemId: '64de12d7e4b00b5b3f3b9008',
      itemId: '607d039360b284ba22e75b0a',
      itemName: 'Boston QA (Incentivio) - Ice Cream',
      displayInfoTitle: 'Ice Cream',
      group: {
        groupId: '607d039360b284ba22e75b0b',
        groupExtId: '805731f6-04ca-4015-9576-aac28d4ea6c6',
        groupType: 'CATALOG_GROUP',
        groupName: 'Boston QA (Incentivio) - Dessert',
        privateAttributes: {},
      },
      options: [
        {
          orderItemId: '64de12d7e4b00b5b3f3b9009',
          itemId: '607d039360b284ba22e75b06',
          itemName: 'Boston QA (Incentivio) - Chocolate',
          displayInfoTitle: 'Chocolate',
          group: {
            groupId: '607d039360b284ba22e75b09',
            groupExtId: '9581c94d-c94b-410d-9545-5c094a3090bc',
            groupType: 'OPTION_GROUP',
            groupName: 'Boston QA (Incentivio) - Flavors',
            privateAttributes: {},
          },
          options: [
            {
              orderItemId: '64de12d7e4b00b5b3f3b900a',
              itemId: '609e3ab960b211f0ffe0ad0b',
              itemName: 'Boston QA (Incentivio) - Incentivio Special',
              displayInfoTitle: 'Incentivio Special',
              group: {
                groupId: '609e3ab960b211f0ffe0ad0c',
                groupExtId: '477f4625-a2e5-441f-bdb4-dc6e6cec8b33',
                groupType: 'OPTION_GROUP',
                groupName: 'Boston QA (Incentivio) - 3x Large',
                privateAttributes: {},
              },
              options: [
                {
                  orderItemId: '64de12d7e4b00b5b3f3b900b',
                  itemId: '609e485460b211f0ffe0ad35',
                  itemName:
                    'Boston QA (Incentivio) - Sliced and fried shallots',
                  displayInfoTitle: 'Sliced and fried shallots',
                  group: {
                    groupId: '609e485460b211f0ffe0ad38',
                    groupExtId: '8793eed8-0041-4352-b97f-e0778b63888a',
                    groupType: 'OPTION_GROUP',
                    groupName: 'Boston QA (Incentivio) - Select an add on',
                    privateAttributes: {},
                  },
                  options: null,
                  notes: null,
                  sku: '',
                  upc: '',
                  unitPrice: 1000,
                  uom: '',
                  quantity: 1,
                  itemDiscounts: null,
                  additionalAttributes: {},
                  externalId: '8643ec6d-b80a-4e77-8e66-ca61b761140f',
                  itemInstructions: '',
                  displayInfo: {
                    langCode: 'EN',
                    title: 'Sliced and fried shallots',
                    shortDescription: '',
                    longDescription: '',
                    smallImage: [],
                    mediumImage: [],
                  },
                  privateAttributes: {
                    DISPLAY_RANK: '1',
                  },
                  itemTotal: {
                    preDiscountSubtotal: 1000,
                    taxSummary: null,
                    chargeSummary: null,
                    subtotal: 1000,
                    total: 1000,
                    additionalAttributes: null,
                  },
                },
              ],
              notes: null,
              sku: '',
              upc: '',
              unitPrice: 1320,
              uom: '',
              quantity: 1,
              itemDiscounts: null,
              additionalAttributes: {},
              externalId: '77535bd0-8bb5-4574-8e00-d4b16098bbd2',
              itemInstructions: '',
              displayInfo: {
                langCode: 'EN',
                title: 'Incentivio Special',
                shortDescription: '',
                longDescription: '',
                smallImage: [],
                mediumImage: [],
              },
              privateAttributes: {
                DISPLAY_RANK: '2',
              },
              itemTotal: {
                preDiscountSubtotal: 2320,
                taxSummary: null,
                chargeSummary: null,
                subtotal: 2320,
                total: 2320,
                additionalAttributes: null,
              },
            },
          ],
          notes: null,
          sku: '',
          upc: '',
          unitPrice: 2000,
          uom: '',
          quantity: 1,
          itemDiscounts: null,
          additionalAttributes: {},
          externalId: 'eed36807-1086-40a5-83b7-76c30f947de3',
          itemInstructions: '',
          displayInfo: {
            langCode: 'EN',
            title: 'Chocolate',
            shortDescription: '',
            longDescription: '',
            smallImage: [],
            mediumImage: [],
          },
          privateAttributes: {
            DISPLAY_RANK: '2',
          },
          itemTotal: {
            preDiscountSubtotal: 4320,
            taxSummary: null,
            chargeSummary: null,
            subtotal: 4320,
            total: 4320,
            additionalAttributes: null,
          },
        },
      ],
      notes: null,
      sku: '',
      upc: '',
      unitPrice: 5000,
      uom: '',
      quantity: 1,
      itemDiscounts: [
        {
          discountId: '4f538d67-e957-400a-8b46-67a7f80fac4a',
          extDiscountId: '2f43febf-491a-4174-a9a8-afe827031088',
          distributedOfferId: '659e79e0-0b25-43ed-bad4-a3b8c729ddcd',
          description: 'Item level Offer',
          discountType: 'PERCENTAGE',
          pointsCost: 0,
          discountAmount: 0,
          discountPercentage: 0.5,
          appliedDiscount: 7250,
          displayAppliedDiscount: '7.25',
        },
      ],
      additionalAttributes: {
        PRICE_CALCULATION_MODE: 'dynamic',
        recommendation_status: 'PRE',
      },
      externalId: '781f78e3-c08e-4f75-b877-9d2d5c1336de',
      itemInstructions: '',
      displayInfo: {
        langCode: 'EN',
        title: 'Ice Cream',
        shortDescription: '',
        longDescription: '',
        smallImage: [
          'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/i/Boston%20QA%20%28Incentivio%29%20-%20Ice%20Cream-64476ebc_1.png',
        ],
        mediumImage: [
          'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/i/Boston%20QA%20%28Incentivio%29%20-%20Ice%20Cream-64476ec1_1-md.png',
        ],
      },
      privateAttributes: {
        DISPLAY_RANK: '1',
      },
      itemTotal: {
        preDiscountSubtotal: 9320,
        taxSummary: null,
        chargeSummary: null,
        subtotal: 9320,
        total: 9320,
        additionalAttributes: null,
      },
    },
    {
      orderItemId: '64de1300e4b00b5b3f3b901a',
      itemId: '607d039360b284ba22e75af2',
      itemName: 'Boston QA (Incentivio) - Sweet Potato Fries',
      displayInfoTitle: 'Sweet Potato Fries',
      group: {
        groupId: '607d039360b284ba22e75b4a',
        groupExtId: '9fd84215-7c08-46a0-a20c-229a630ec078',
        groupType: 'CATALOG_GROUP',
        groupName: 'Boston QA - Soups',
        privateAttributes: {},
      },
      options: null,
      notes: null,
      sku: '',
      upc: '',
      unitPrice: 2000,
      uom: '',
      quantity: 1,
      itemDiscounts: null,
      additionalAttributes: {
        recommendation_status: 'PRE',
      },
      externalId: '9e1eaeed-8818-4d80-b92f-68c99a0d17e5',
      itemInstructions: '',
      displayInfo: {
        langCode: 'EN',
        title: 'Sweet Potato Fries',
        shortDescription:
          'Sweet potato fries are slightly higher in calories and carbs but also more nutrient-dense than French fries. The greatest nutrient difference is that French fries have no vitamin A - Toast',
        longDescription: '',
        smallImage: [
          'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/i/2050%20Yonge%20copy%20-%20DO%20NOT%20USE%20-%20Sweet%20Potato%20FriesSM_1.png',
        ],
        mediumImage: [
          'https://incentdev.s3.amazonaws.com/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/i/Sweet%20Potato%20Fries-md.jpg',
        ],
      },
      privateAttributes: {
        DISPLAY_RANK: '4',
      },
      itemTotal: {
        preDiscountSubtotal: 2000,
        taxSummary: null,
        chargeSummary: null,
        subtotal: 2000,
        total: 2000,
        additionalAttributes: null,
      },
    },
    {
      orderItemId: '64de1700e4b00b5b3f3b9089',
      itemId: '607d039360b284ba22e75b49',
      itemName: 'Boston QA (Incentivio) - French Onion',
      displayInfoTitle: 'French Onion',
      group: {
        groupId: '607d039360b284ba22e75b4a',
        groupExtId: '9fd84215-7c08-46a0-a20c-229a630ec078',
        groupType: 'CATALOG_GROUP',
        groupName: 'Boston QA - Soups',
        privateAttributes: {},
      },
      options: [
        {
          orderItemId: '64de1700e4b00b5b3f3b908a',
          itemId: '607d039360b284ba22e75b2b',
          itemName: 'Boston QA (Incentivio) - Noodles',
          displayInfoTitle: 'Noodles',
          group: {
            groupId: '607d039360b284ba22e75b36',
            groupExtId: '76f7261f-f3a2-4dba-979d-a60d83f98f29',
            groupType: 'OPTION_GROUP',
            groupName: 'Boston QA (Incentivio) - Add Ins',
            privateAttributes: {},
          },
          options: null,
          notes: null,
          sku: '',
          upc: '',
          unitPrice: 8450,
          uom: '',
          quantity: 2,
          itemDiscounts: null,
          additionalAttributes: {},
          externalId: 'ce48abb9-943f-472e-b4f7-023244e0b028',
          itemInstructions: '',
          displayInfo: {
            langCode: 'EN',
            title: 'Noodles',
            shortDescription: '',
            longDescription: '',
            smallImage: [],
            mediumImage: [],
          },
          privateAttributes: {
            DISPLAY_RANK: '3',
          },
          itemTotal: {
            preDiscountSubtotal: 16900,
            taxSummary: null,
            chargeSummary: null,
            subtotal: 16900,
            total: 16900,
            additionalAttributes: null,
          },
        },
      ],
      notes: null,
      sku: '',
      upc: '',
      unitPrice: 6750,
      uom: '',
      quantity: 1,
      itemDiscounts: null,
      additionalAttributes: {
        recommendation_status: 'PRE',
      },
      externalId: '821a86f8-9e9d-41fb-a82d-6cefd60ef826',
      itemInstructions: '',
      displayInfo: {
        langCode: 'EN',
        title: 'French Onion',
        shortDescription:
          'French onion soup is a type of soup usually based on meat stock and onions, and often served gratinéed with croutons or a larger piece of bread covered with cheese floating on top.',
        longDescription: '',
        smallImage: [
          'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/i/Boston%20QA%20%28Incentivio%29%20-%20French%20Onion-61f14442_1.jpg',
        ],
        mediumImage: [
          'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/i/Boston%20QA%20%28Incentivio%29%20-%20French%20Onion-61f14444_1-md.jpg',
        ],
      },
      privateAttributes: {
        DISPLAY_RANK: '4',
      },
      itemTotal: {
        preDiscountSubtotal: 23650,
        taxSummary: null,
        chargeSummary: null,
        subtotal: 23650,
        total: 23650,
        additionalAttributes: null,
      },
    },
    {
      orderItemId: '64de131be4b00b5b3f3b901b',
      itemId: '607d039360b284ba22e75af6',
      itemName: 'Boston QA (Incentivio) - Honey BBQ',
      displayInfoTitle: 'Honey BBQ',
      group: {
        groupId: '607d039360b284ba22e75b4a',
        groupExtId: '9fd84215-7c08-46a0-a20c-229a630ec078',
        groupType: 'CATALOG_GROUP',
        groupName: 'Boston QA - Soups',
        privateAttributes: {},
      },
      options: [
        {
          orderItemId: '64de131be4b00b5b3f3b901c',
          itemId: '607d039360b284ba22e75af9',
          itemName: 'Boston QA (Incentivio) - Twelve',
          displayInfoTitle: 'Twelve',
          group: {
            groupId: '607d039360b284ba22e75afa',
            groupExtId: '7c27a94a-a4db-443c-8c1e-cd7d35a385fe',
            groupType: 'OPTION_GROUP',
            groupName: 'Boston QA (Incentivio) - Size',
            privateAttributes: {},
          },
          options: null,
          notes: null,
          sku: '',
          upc: '',
          unitPrice: 12000,
          uom: '',
          quantity: 1,
          itemDiscounts: null,
          additionalAttributes: {},
          externalId: 'c7b7733d-7554-4832-b4fd-679a55db1798',
          itemInstructions: '',
          displayInfo: {
            langCode: 'EN',
            title: 'Twelve',
            shortDescription: '',
            longDescription: '',
            smallImage: [],
            mediumImage: [],
          },
          privateAttributes: {
            DISPLAY_RANK: '1',
          },
          itemTotal: {
            preDiscountSubtotal: 12000,
            taxSummary: null,
            chargeSummary: null,
            subtotal: 12000,
            total: 12000,
            additionalAttributes: null,
          },
        },
      ],
      notes: null,
      sku: '',
      upc: '',
      unitPrice: 5000,
      uom: '',
      quantity: 5,
      itemDiscounts: null,
      additionalAttributes: {
        recommendation_status: 'PRE',
      },
      externalId: 'ab678076-c983-48f3-a795-dce921d477d7',
      itemInstructions: '',
      displayInfo: {
        langCode: 'EN',
        title: 'Honey BBQ',
        shortDescription: '',
        longDescription: '',
        smallImage: [
          'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/i/Boston%20QA%20%28Incentivio%29%20-%20Honey%20BBQ-61f15121_1.jpg',
        ],
        mediumImage: [
          'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/i/Boston%20QA%20%28Incentivio%29%20-%20Honey%20BBQ-61f15126_1-md.jpg',
        ],
      },
      privateAttributes: {
        DISPLAY_RANK: '4',
      },
      itemTotal: {
        preDiscountSubtotal: 85000,
        taxSummary: null,
        chargeSummary: null,
        subtotal: 85000,
        total: 85000,
        additionalAttributes: null,
      },
    },
  ],
  orderDiscounts: [
    {
      discountId: 'a0e13642-49ec-49b8-adb7-19b59276989f',
      extDiscountId: '2f43febf-491a-4174-a9a8-afe827031088',
      distributedOfferId: '50f39827-15cb-47b8-90e7-a9a6da7afd81',
      description: '26-07-2023 Activity',
      discountType: 'PERCENTAGE',
      pointsCost: 0,
      discountAmount: 0,
      discountPercentage: 0.1,
      appliedDiscount: 12000,
      displayAppliedDiscount: '12.00',
    },
  ],
  additionalAttributes: {
    PREP_TIME: 'PT5M',
  },
  checks: [
    {
      checkId: 'c9d2474d-4727-4660-8113-5cfdf4bff8d6',
      extCheckId: null,
      customer: {
        customerId: '3196b5ce-2d63-49d3-8d55-14ac010ad734',
        extCustomerId: '45764',
        firstName: 'Devanshani',
        lastName: 'Rasanjika',
        email: 'devanshani.r@aeturnum.com',
        phone: '2311111111',
      },
      amount: 115680,
      gratuity: 7710,
      payments: [
        {
          paymentTxId: 'd98d3630-a11e-4f4e-b381-7783debda1f6',
          externalTxId: 'GeUAiguIV52gR8xS9kthOvgkixs',
          paidDate: null,
          paymentType: 'CARD_NOT_PRESENT',
          cardType: 'visa',
          lastFour: '1111',
          amount: 115680,
          tipAmount: 7710,
          amountTendered: 115680,
        },
      ],
    },
  ],
  orderTotal: {
    preDiscountSubtotal: 119970,
    taxSummary: {
      totalTaxes: 0,
      taxes: [
        {
          taxId: null,
          taxDescription: 'State Tax',
          taxAmountApplied: 1530,
        },
      ],
    },
    chargeSummary: {
      taxableCharges: 0,
      nonTaxableCharges: 0,
      charges: [
        {
          chargeId: null,
          chargeName: null,
          chargeDescription: 'dynamic charge2',
          taxable: false,
          gratuity: true,
          delivery: false,
          chargeApplied: 660,
          chargeAppliedWithTax: 0,
          taxes: null,
        },
      ],
      totalCharges: 660,
      totalChargesWithTax: 0,
      totalTaxes: 0,
    },
    refundSummary: {
      totalRefundAmount: 0,
      refunds: [],
    },
    subtotal: 107970,
    gratuity: 0,
    total: 107970,
    additionalAttributes: null,
    displayTotal: '107.97',
    displaySubtotal: '107.97',
    displayPreDiscountSubtotal: '119.97',
    displayTotalDiscountApplied: '12.00',
    displayGratuity: '0.00',
    totalTaxApplied: 0,
  },
  itemsCountDetails: {
    totalItemsCount: 8,
    itemsCount: {
      '607d039360b284ba22e75af6': 5,
      '607d039360b284ba22e75af2': 1,
      '607d039360b284ba22e75b49': 1,
      '607d039360b284ba22e75b0a': 1,
    },
  },
  fulfillmentStatus: 'NONE',
  orderSource: 'WEB',
  auditEvents: [
    {
      id: '64de1320e4b00b5b3f3b901d',
      eventName: 'INIT_ORDER_REQUEST_SUBMITTED',
      traceId: '34457ca0f3fcffc7',
      transactionId: null,
      eventTime: '2023-08-17T18:01:28+05:30[Asia/Colombo]',
      description: 'Submitted init order request',
      interventionRequired: false,
      resolved: true,
      resolutionTime: null,
      resolutionComment: null,
      requestedBy: null,
      extendedAttributes: {},
      externalStatuses: {},
      additionalDetails: null,
    },
    {
      id: '64de1320e4b00b5b3f3b901e',
      eventName: 'INIT_ORDER_REQUEST_SUCCESS',
      traceId: '34457ca0f3fcffc7',
      transactionId: null,
      eventTime: '2023-08-17T18:01:28+05:30[Asia/Colombo]',
      description: 'Init order request successful',
      interventionRequired: false,
      resolved: true,
      resolutionTime: null,
      resolutionComment: null,
      requestedBy: null,
      extendedAttributes: {},
      externalStatuses: {},
      additionalDetails: null,
    },
    {
      id: '64de1364e4b00b5b3f3b9024',
      eventName: 'OFFER_APPLICATION_REQUEST_SUBMITTED',
      traceId: 'dc234cdee76c8a7c',
      transactionId: null,
      eventTime: '2023-08-17T18:02:36+05:30[Asia/Colombo]',
      description: 'Offer Application request submitted',
      interventionRequired: false,
      resolved: true,
      resolutionTime: null,
      resolutionComment: null,
      requestedBy: null,
      extendedAttributes: {
        OFFER_ID: '2e602e09-2536-4d5b-a9e3-4663156b46d8',
      },
      externalStatuses: {},
      additionalDetails: null,
    },
    {
      id: '64de1364e4b00b5b3f3b9025',
      eventName: 'OFFER_APPLICATION_SUCCESS',
      traceId: 'dc234cdee76c8a7c',
      transactionId: null,
      eventTime: '2023-08-17T18:02:36+05:30[Asia/Colombo]',
      description: 'Offer Application successful',
      interventionRequired: false,
      resolved: true,
      resolutionTime: null,
      resolutionComment: null,
      requestedBy: null,
      extendedAttributes: {
        OFFER_ID: '2e602e09-2536-4d5b-a9e3-4663156b46d8',
      },
      externalStatuses: {},
      additionalDetails: null,
    },
    {
      id: '64de136ee4b00b5b3f3b9026',
      eventName: 'OFFER_REDEMPTION_REQUEST_SUBMITTED',
      traceId: 'fa0e62aec0c1476f',
      transactionId: null,
      eventTime: '2023-08-17T18:02:46+05:30[Asia/Colombo]',
      description: 'Submitted Offer Redemption request',
      interventionRequired: false,
      resolved: true,
      resolutionTime: null,
      resolutionComment: null,
      requestedBy: null,
      extendedAttributes: {},
      externalStatuses: {},
      additionalDetails: null,
    },
    {
      id: '64de136ee4b00b5b3f3b9027',
      eventName: 'OFFER_REDEMPTION_SUCCESS',
      traceId: 'fa0e62aec0c1476f',
      transactionId: null,
      eventTime: '2023-08-17T18:02:46+05:30[Asia/Colombo]',
      description: 'Offer Redemption successful',
      interventionRequired: false,
      resolved: true,
      resolutionTime: null,
      resolutionComment: null,
      requestedBy: null,
      extendedAttributes: {},
      externalStatuses: {},
      additionalDetails: null,
    },
    {
      id: '64de136ee4b00b5b3f3b9029',
      eventName: 'PAYMENT_REQUEST_SUBMITTED',
      traceId: 'fa0e62aec0c1476f',
      transactionId: '64de136ee4b00b5b3f3b9028',
      eventTime: '2023-08-17T18:02:46+05:30[Asia/Colombo]',
      description: 'Submitted Payment Transaction',
      interventionRequired: false,
      resolved: true,
      resolutionTime: null,
      resolutionComment: null,
      requestedBy: null,
      extendedAttributes: {
        BROWSER_INFO:
          'eyJ3aWR0aCI6MTUzNiwiaGVpZ2h0Ijo4NjQsImRlcHRoIjoyNCwidGltZXpvbmUiOi0zMzAsInVzZXJfYWdlbnQiOiJNb3ppbGxhLzUuMCAoV2luZG93cyBOVCAxMC4wOyBXaW42NDsgeDY0KSBBcHBsZVdlYktpdC81MzcuMzYgKEtIVE1MLCBsaWtlIEdlY2tvKSBDaHJvbWUvMTE2LjAuMC4wIFNhZmFyaS81MzcuMzYiLCJqYXZhIjpmYWxzZSwibGFuZ3VhZ2UiOiJlbi1VUyIsImJyb3dzZXJfc2l6ZSI6IjA1IiwiYWNjZXB0X2hlYWRlciI6InRleHQvaHRtbCxhcHBsaWNhdGlvbi94aHRtbCt4bWwsYXBwbGljYXRpb24veG1sO3E9MC45LGltYWdlL2F2aWYsaW1hZ2Uvd2VicCxpbWFnZS9hcG5nLCovKjtxPTAuOCxhcHBsaWNhdGlvbi9zaWduZWQtZXhjaGFuZ2U7dj1iMztxPTAuNyJ9',
        IP: '112.135.73.252',
      },
      externalStatuses: {},
      additionalDetails: null,
    },
    {
      id: '64de136ee4b00b5b3f3b902a',
      eventName: 'PAYMENT_SUCCESS',
      traceId: 'fa0e62aec0c1476f',
      transactionId: '64de136ee4b00b5b3f3b9028',
      eventTime: '2023-08-17T18:02:46+05:30[Asia/Colombo]',
      description: 'Payment completed successfully.',
      interventionRequired: false,
      resolved: true,
      resolutionTime: null,
      resolutionComment: null,
      requestedBy: null,
      extendedAttributes: {
        CARD_TYPE: 'visa',
        paymentTxId: '0e9c0d9c-7f60-44b0-9b14-13220f119483',
        LAST_FOUR: '1111',
      },
      externalStatuses: {},
      additionalDetails: null,
    },
    {
      id: '64de136ee4b00b5b3f3b902b',
      eventName: 'ORDER_REQUEST_SUBMITTED',
      traceId: 'fa0e62aec0c1476f',
      transactionId: '64de12c3e4b00b5b3f3b8ff5',
      eventTime: '2023-08-17T18:02:46+05:30[Asia/Colombo]',
      description: 'Submitted Order Transaction',
      interventionRequired: false,
      resolved: true,
      resolutionTime: null,
      resolutionComment: null,
      requestedBy: null,
      extendedAttributes: {},
      externalStatuses: {},
      additionalDetails: null,
    },
    {
      id: '64de13aae4b00b5b3f3b902c',
      eventName: 'ORDER_TIMEOUT',
      traceId: 'fa0e62aec0c1476f',
      transactionId: '64de12c3e4b00b5b3f3b8ff5',
      eventTime: '2023-08-17T18:03:46+05:30[Asia/Colombo]',
      description:
        'A timeout occurred during order processing. Verification required.',
      interventionRequired: true,
      resolved: false,
      resolutionTime: null,
      resolutionComment: null,
      requestedBy: null,
      extendedAttributes: {},
      externalStatuses: {},
      additionalDetails: null,
    },
    {
      id: '64de13aae4b00b5b3f3b902d',
      eventName: 'ORDER_REVERSAL_REQUEST_SUBMITTED',
      traceId: 'fa0e62aec0c1476f',
      transactionId: '64de12c3e4b00b5b3f3b8ff5',
      eventTime: '2023-08-17T18:03:46+05:30[Asia/Colombo]',
      description: 'Submitted Order Reversal',
      interventionRequired: false,
      resolved: true,
      resolutionTime: null,
      resolutionComment: null,
      requestedBy: null,
      extendedAttributes: {},
      externalStatuses: {},
      additionalDetails: null,
    },
    {
      id: '64de13e6e4b00b5b3f3b902e',
      eventName: 'ORDER_REVERSAL_TIMEOUT',
      traceId: 'fa0e62aec0c1476f',
      transactionId: '64de12c3e4b00b5b3f3b8ff5',
      eventTime: '2023-08-17T18:04:46+05:30[Asia/Colombo]',
      description:
        'A timeout occurred during order reversal. Verification required.',
      interventionRequired: true,
      resolved: false,
      resolutionTime: null,
      resolutionComment: null,
      requestedBy: null,
      extendedAttributes: {},
      externalStatuses: {},
      additionalDetails: null,
    },
    {
      id: '64de13e6e4b00b5b3f3b9030',
      eventName: 'PAYMENT_REVERSAL_REQUEST_SUBMITTED',
      traceId: 'fa0e62aec0c1476f',
      transactionId: '64de136ee4b00b5b3f3b9028',
      eventTime: '2023-08-17T18:04:46+05:30[Asia/Colombo]',
      description: 'Submitted Payment Reversal',
      interventionRequired: false,
      resolved: true,
      resolutionTime: null,
      resolutionComment: null,
      requestedBy: null,
      extendedAttributes: {
        paymentTxId: '64de13e6e4b00b5b3f3b902f',
      },
      externalStatuses: {},
      additionalDetails: null,
    },
    {
      id: '64de13e6e4b00b5b3f3b9031',
      eventName: 'PAYMENT_REVERSAL_SUCCESS',
      traceId: 'fa0e62aec0c1476f',
      transactionId: '64de136ee4b00b5b3f3b9028',
      eventTime: '2023-08-17T18:04:46+05:30[Asia/Colombo]',
      description: 'Payment was successfully reversed.',
      interventionRequired: false,
      resolved: true,
      resolutionTime: null,
      resolutionComment: null,
      requestedBy: null,
      extendedAttributes: {
        paymentTxId: '64de13e6e4b00b5b3f3b902f',
      },
      externalStatuses: {
        TX_STATUS: 'Succeeded!',
        AMOUNT: '0',
        TRANSACTION_ID: 'Lc8UL4SmEnbPU9Omy3xMHJ96Krk',
      },
      additionalDetails: null,
    },
    {
      id: '64de13e6e4b00b5b3f3b9032',
      eventName: 'OFFER_REDEMPTION_REVERSAL_SUBMITTED',
      traceId: 'fa0e62aec0c1476f',
      transactionId: '64de136ee4b00b5b3f3b9028',
      eventTime: '2023-08-17T18:04:46+05:30[Asia/Colombo]',
      description: 'Submitted Offer Redemption request',
      interventionRequired: false,
      resolved: true,
      resolutionTime: null,
      resolutionComment: null,
      requestedBy: null,
      extendedAttributes: {},
      externalStatuses: {},
      additionalDetails: null,
    },
    {
      id: '64de13e6e4b00b5b3f3b9033',
      eventName: 'OFFER_REDEMPTION_REVERSAL_SUCCESS',
      traceId: 'fa0e62aec0c1476f',
      transactionId: '64de136ee4b00b5b3f3b9028',
      eventTime: '2023-08-17T18:04:46+05:30[Asia/Colombo]',
      description: 'Offer Redemption successful',
      interventionRequired: false,
      resolved: true,
      resolutionTime: null,
      resolutionComment: null,
      requestedBy: null,
      extendedAttributes: {},
      externalStatuses: {},
      additionalDetails: null,
    },
    {
      id: '64de1412e4b00b5b3f3b9040',
      eventName: 'INIT_ORDER_REQUEST_SUBMITTED',
      traceId: 'a84aa8c09bf5944d',
      transactionId: null,
      eventTime: '2023-08-17T18:05:30+05:30[Asia/Colombo]',
      description: 'Submitted init order request',
      interventionRequired: false,
      resolved: true,
      resolutionTime: null,
      resolutionComment: null,
      requestedBy: null,
      extendedAttributes: {},
      externalStatuses: {},
      additionalDetails: null,
    },
    {
      id: '64de1412e4b00b5b3f3b9041',
      eventName: 'INIT_ORDER_REQUEST_SUCCESS',
      traceId: 'a84aa8c09bf5944d',
      transactionId: null,
      eventTime: '2023-08-17T18:05:30+05:30[Asia/Colombo]',
      description: 'Init order request successful',
      interventionRequired: false,
      resolved: true,
      resolutionTime: null,
      resolutionComment: null,
      requestedBy: null,
      extendedAttributes: {},
      externalStatuses: {},
      additionalDetails: null,
    },
    {
      id: '64de1705e4b00b5b3f3b908b',
      eventName: 'INIT_ORDER_REQUEST_SUBMITTED',
      traceId: '0747addf3bcc7d4e',
      transactionId: null,
      eventTime: '2023-08-17T18:18:05+05:30[Asia/Colombo]',
      description: 'Submitted init order request',
      interventionRequired: false,
      resolved: true,
      resolutionTime: null,
      resolutionComment: null,
      requestedBy: null,
      extendedAttributes: {},
      externalStatuses: {},
      additionalDetails: null,
    },
    {
      id: '64de1705e4b00b5b3f3b908c',
      eventName: 'INIT_ORDER_REQUEST_SUCCESS',
      traceId: '0747addf3bcc7d4e',
      transactionId: null,
      eventTime: '2023-08-17T18:18:05+05:30[Asia/Colombo]',
      description: 'Init order request successful',
      interventionRequired: false,
      resolved: true,
      resolutionTime: null,
      resolutionComment: null,
      requestedBy: null,
      extendedAttributes: {},
      externalStatuses: {},
      additionalDetails: null,
    },
    {
      id: '64de1733e4b00b5b3f3b908e',
      eventName: 'OFFER_APPLICATION_REQUEST_SUBMITTED',
      traceId: '1cd30c283142b0bc',
      transactionId: null,
      eventTime: '2023-08-17T18:18:51+05:30[Asia/Colombo]',
      description: 'Offer Application request submitted',
      interventionRequired: false,
      resolved: true,
      resolutionTime: null,
      resolutionComment: null,
      requestedBy: null,
      extendedAttributes: {
        OFFER_ID: 'a0e13642-49ec-49b8-adb7-19b59276989f',
      },
      externalStatuses: {},
      additionalDetails: null,
    },
    {
      id: '64de1733e4b00b5b3f3b908f',
      eventName: 'OFFER_APPLICATION_SUCCESS',
      traceId: '1cd30c283142b0bc',
      transactionId: null,
      eventTime: '2023-08-17T18:18:51+05:30[Asia/Colombo]',
      description: 'Offer Application successful',
      interventionRequired: false,
      resolved: true,
      resolutionTime: null,
      resolutionComment: null,
      requestedBy: null,
      extendedAttributes: {
        OFFER_ID: 'a0e13642-49ec-49b8-adb7-19b59276989f',
      },
      externalStatuses: {},
      additionalDetails: null,
    },
    {
      id: '64de173fe4b00b5b3f3b9096',
      eventName: 'OFFER_REDEMPTION_REQUEST_SUBMITTED',
      traceId: '160b589c1c16529d',
      transactionId: null,
      eventTime: '2023-08-17T18:19:03+05:30[Asia/Colombo]',
      description: 'Submitted Offer Redemption request',
      interventionRequired: false,
      resolved: true,
      resolutionTime: null,
      resolutionComment: null,
      requestedBy: null,
      extendedAttributes: {},
      externalStatuses: {},
      additionalDetails: null,
    },
    {
      id: '64de173fe4b00b5b3f3b9097',
      eventName: 'OFFER_REDEMPTION_SUCCESS',
      traceId: '160b589c1c16529d',
      transactionId: null,
      eventTime: '2023-08-17T18:19:03+05:30[Asia/Colombo]',
      description: 'Offer Redemption successful',
      interventionRequired: false,
      resolved: true,
      resolutionTime: null,
      resolutionComment: null,
      requestedBy: null,
      extendedAttributes: {},
      externalStatuses: {},
      additionalDetails: null,
    },
    {
      id: '64de173fe4b00b5b3f3b9099',
      eventName: 'PAYMENT_REQUEST_SUBMITTED',
      traceId: '160b589c1c16529d',
      transactionId: '64de173fe4b00b5b3f3b9098',
      eventTime: '2023-08-17T18:19:03+05:30[Asia/Colombo]',
      description: 'Submitted Payment Transaction',
      interventionRequired: false,
      resolved: true,
      resolutionTime: null,
      resolutionComment: null,
      requestedBy: null,
      extendedAttributes: {
        BROWSER_INFO:
          'eyJ3aWR0aCI6MTUzNiwiaGVpZ2h0Ijo4NjQsImRlcHRoIjoyNCwidGltZXpvbmUiOi0zMzAsInVzZXJfYWdlbnQiOiJNb3ppbGxhLzUuMCAoV2luZG93cyBOVCAxMC4wOyBXaW42NDsgeDY0KSBBcHBsZVdlYktpdC81MzcuMzYgKEtIVE1MLCBsaWtlIEdlY2tvKSBDaHJvbWUvMTE2LjAuMC4wIFNhZmFyaS81MzcuMzYiLCJqYXZhIjpmYWxzZSwibGFuZ3VhZ2UiOiJlbi1VUyIsImJyb3dzZXJfc2l6ZSI6IjA1IiwiYWNjZXB0X2hlYWRlciI6InRleHQvaHRtbCxhcHBsaWNhdGlvbi94aHRtbCt4bWwsYXBwbGljYXRpb24veG1sO3E9MC45LGltYWdlL2F2aWYsaW1hZ2Uvd2VicCxpbWFnZS9hcG5nLCovKjtxPTAuOCxhcHBsaWNhdGlvbi9zaWduZWQtZXhjaGFuZ2U7dj1iMztxPTAuNyJ9',
        IP: '112.135.73.252',
      },
      externalStatuses: {},
      additionalDetails: null,
    },
    {
      id: '64de173fe4b00b5b3f3b909a',
      eventName: 'PAYMENT_SUCCESS',
      traceId: '160b589c1c16529d',
      transactionId: '64de173fe4b00b5b3f3b9098',
      eventTime: '2023-08-17T18:19:03+05:30[Asia/Colombo]',
      description: 'Payment completed successfully.',
      interventionRequired: false,
      resolved: true,
      resolutionTime: null,
      resolutionComment: null,
      requestedBy: null,
      extendedAttributes: {
        CARD_TYPE: 'visa',
        paymentTxId: 'd98d3630-a11e-4f4e-b381-7783debda1f6',
        LAST_FOUR: '1111',
      },
      externalStatuses: {},
      additionalDetails: null,
    },
    {
      id: '64de173fe4b00b5b3f3b909b',
      eventName: 'ORDER_REQUEST_SUBMITTED',
      traceId: '160b589c1c16529d',
      transactionId: '64de12c3e4b00b5b3f3b8ff5',
      eventTime: '2023-08-17T18:19:03+05:30[Asia/Colombo]',
      description: 'Submitted Order Transaction',
      interventionRequired: false,
      resolved: true,
      resolutionTime: null,
      resolutionComment: null,
      requestedBy: null,
      extendedAttributes: {},
      externalStatuses: {},
      additionalDetails: null,
    },
    {
      id: '64de177be4b00b5b3f3b90a3',
      eventName: 'ORDER_TIMEOUT',
      traceId: '160b589c1c16529d',
      transactionId: '64de12c3e4b00b5b3f3b8ff5',
      eventTime: '2023-08-17T18:20:03+05:30[Asia/Colombo]',
      description:
        'A timeout occurred during order processing. Verification required.',
      interventionRequired: true,
      resolved: false,
      resolutionTime: null,
      resolutionComment: null,
      requestedBy: null,
      extendedAttributes: {},
      externalStatuses: {},
      additionalDetails: null,
    },
    {
      id: '64de177be4b00b5b3f3b90a4',
      eventName: 'ORDER_REVERSAL_REQUEST_SUBMITTED',
      traceId: '160b589c1c16529d',
      transactionId: '64de12c3e4b00b5b3f3b8ff5',
      eventTime: '2023-08-17T18:20:03+05:30[Asia/Colombo]',
      description: 'Submitted Order Reversal',
      interventionRequired: false,
      resolved: true,
      resolutionTime: null,
      resolutionComment: null,
      requestedBy: null,
      extendedAttributes: {},
      externalStatuses: {},
      additionalDetails: null,
    },
    {
      id: '64de17b7e4b00b5b3f3b90a5',
      eventName: 'ORDER_REVERSAL_TIMEOUT',
      traceId: '160b589c1c16529d',
      transactionId: '64de12c3e4b00b5b3f3b8ff5',
      eventTime: '2023-08-17T18:21:03+05:30[Asia/Colombo]',
      description:
        'A timeout occurred during order reversal. Verification required.',
      interventionRequired: true,
      resolved: false,
      resolutionTime: null,
      resolutionComment: null,
      requestedBy: null,
      extendedAttributes: {},
      externalStatuses: {},
      additionalDetails: null,
    },
    {
      id: '64de17b7e4b00b5b3f3b90a7',
      eventName: 'PAYMENT_REVERSAL_REQUEST_SUBMITTED',
      traceId: '160b589c1c16529d',
      transactionId: '64de173fe4b00b5b3f3b9098',
      eventTime: '2023-08-17T18:21:03+05:30[Asia/Colombo]',
      description: 'Submitted Payment Reversal',
      interventionRequired: false,
      resolved: true,
      resolutionTime: null,
      resolutionComment: null,
      requestedBy: null,
      extendedAttributes: {
        paymentTxId: '64de17b7e4b00b5b3f3b90a6',
      },
      externalStatuses: {},
      additionalDetails: null,
    },
    {
      id: '64de17b7e4b00b5b3f3b90a8',
      eventName: 'PAYMENT_REVERSAL_SUCCESS',
      traceId: '160b589c1c16529d',
      transactionId: '64de173fe4b00b5b3f3b9098',
      eventTime: '2023-08-17T18:21:03+05:30[Asia/Colombo]',
      description: 'Payment was successfully reversed.',
      interventionRequired: false,
      resolved: true,
      resolutionTime: null,
      resolutionComment: null,
      requestedBy: null,
      extendedAttributes: {
        paymentTxId: '64de17b7e4b00b5b3f3b90a6',
      },
      externalStatuses: {
        TX_STATUS: 'Succeeded!',
        AMOUNT: '0',
        TRANSACTION_ID: 'GeUAiguIV52gR8xS9kthOvgkixs',
      },
      additionalDetails: null,
    },
    {
      id: '64de17b7e4b00b5b3f3b90a9',
      eventName: 'OFFER_REDEMPTION_REVERSAL_SUBMITTED',
      traceId: '160b589c1c16529d',
      transactionId: '64de173fe4b00b5b3f3b9098',
      eventTime: '2023-08-17T18:21:03+05:30[Asia/Colombo]',
      description: 'Submitted Offer Redemption request',
      interventionRequired: false,
      resolved: true,
      resolutionTime: null,
      resolutionComment: null,
      requestedBy: null,
      extendedAttributes: {},
      externalStatuses: {},
      additionalDetails: null,
    },
    {
      id: '64de17b8e4b00b5b3f3b90aa',
      eventName: 'OFFER_REDEMPTION_REVERSAL_SUCCESS',
      traceId: '160b589c1c16529d',
      transactionId: '64de173fe4b00b5b3f3b9098',
      eventTime: '2023-08-17T18:21:04+05:30[Asia/Colombo]',
      description: 'Offer Redemption successful',
      interventionRequired: false,
      resolved: true,
      resolutionTime: null,
      resolutionComment: null,
      requestedBy: null,
      extendedAttributes: {},
      externalStatuses: {},
      additionalDetails: null,
    },
    {
      id: '6530ca51e4b0e1137d450f58',
      eventName: 'ORDER_REFUND_SUCCESS',
      traceId: '35cf9594a2436a4f',
      transactionId: '6530c8d3e4b0e1137d450f44',
      eventTime: '2023-10-19T11:48:57+05:30[Asia/Colombo]',
      description: 'Order refund was successful. Refund reason: test',
      interventionRequired: false,
      resolved: true,
      resolutionTime: null,
      resolutionComment: null,
      requestedBy: {
        adminAccountAuthorization: {
          dateCreated: '2023-10-09T09:00:27.004Z',
          dateUpdated: '2023-10-10T11:54:32.912Z',
          all: false,
          clientIdRoleIds: {
            '1b63163d-1aba-4944-bbc1-ebc495d9dc5c': 1,
          },
          clients: [
            {
              all: false,
              id: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
              merchants: [
                {
                  all: true,
                  id: '238f878f-fe74-4e41-a838-0f799bc58662',
                  locations: [],
                },
                {
                  all: true,
                  id: '73c25df9-b8d5-4d89-9944-dbbdc0c8a117',
                  locations: [],
                },
                {
                  all: true,
                  id: '84ace984-71ec-4488-b7fd-cb7bc24a881c',
                  locations: [],
                },
                {
                  all: true,
                  id: '7f3ffb13-7c1c-4909-9efb-b067b1728f12',
                  locations: [],
                },
                {
                  all: true,
                  id: '9458ce51-e44a-451a-b8a3-beb15d1ddbaf',
                  locations: [],
                },
                {
                  all: true,
                  id: '392eca08-00c7-4f81-ae98-f346a54fb867',
                  locations: [],
                },
                {
                  all: true,
                  id: 'bfdaf49b-938f-46ff-9b47-f9620d994353',
                  locations: [],
                },
                {
                  all: true,
                  id: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
                  locations: [],
                },
                {
                  all: true,
                  id: '5f7e5664-8e7c-48fc-aaee-8e9b35b2fdca',
                  locations: [],
                },
                {
                  all: true,
                  id: '0d18d2b3-7de0-4e16-b68e-f28a92bb8737',
                  locations: [],
                },
              ],
            },
          ],
        },
      },
    },
  ],
  orderOptionName: 'Pick 01',
};
